export const ADMIN_AGENT = 'adminz@adminz.com'
export const JPM_AGENT = 'jpm12200@gmail.com'

export const PROD_653_NU = false
export const VERSION_THCH = 'v100.0.11'
